import NavigationBar from "../../../navigation_components/NavigationBar";
import CustomerUserSideBar from "../../../sidebar_components/CustomerUserSideBar";
import "../../../../styles/workspace_styles/CustomerUserStyles/HomePage/HomePage.css";
import { useEffect } from "react";

const HomePage = () =>{
    useEffect(() =>{
        document.title = 'Blinke IOT | Home';
    },[]);
    return(
        <div className="customer-user-home-page">
            <NavigationBar/>
            <div className="customer-user-home-page-layout">
                <div>
                    <CustomerUserSideBar/>
                </div>
                <div className="customer-user-home-page-parent-container">
                    <div className="customer-user-home-page-container">
                        <h2>Blink IOT Portal</h2>
                        <div className="customer-user-home-page-grid">
                            <div>
                                <h2>Manage Devices Anywhere</h2>
                                <p>Monitor devices diagnostics remotely.</p>
                            </div>
                            <div>
                                <h2>Real-Time Monitoring</h2>
                                <p>See live updates on device status and performance.</p>
                            </div>
                            <div>
                                <h2>Secure Data</h2>
                                <p>Your data is encrypted and safely stored.</p>
                            </div>
                            <div>
                                <h2>Visualize Your Data</h2>
                                <p>View your device data through the dashboards our platform provides.</p>
                            </div>
                            <div>
                                <h2>Real-Time Support</h2>
                                <p>Get immediate help and assistance whenever you need it.</p>
                            </div>
                            <div>
                                <h2>Unified Device Control</h2>
                                <p>All your devices managed in one place effortlessly.</p>
                            </div>
                            <div>
                                <h2>Seamless Onboarding</h2>
                                <p>Get started immediately with our team guiding you every step.</p>
                            </div>
                            <div>
                                <h2>Optimized Workflow</h2>
                                <p>Streamline your IoT operations and manage tasks efficiently.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HomePage;